<template>
  <div class="col-md-12" style="margin-top: 3%">
    <v-layout row wrap>
      <v-flex lg3 md4 sm6 xs12>
        <v-container fluid>
          <v-autocomplete
            label="Activity"
            v-model="activity.inventory"
            :items="inventoryWithPrices"
            :rules="[(v) => !!v || 'Item is required']"
            required
            item-text="name"
            item-value="inventory"
            :return-object="true"
            @change="resetActivity"
            :loading="$loadingTrue"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex lg3 md4 sm6 xs12>
        <v-container>
          <v-dialog
            ref="dialog"
            persistent
            v-model="modal"
            lazy
            full-width
            width="290px"
            :return-value.sync="activity.date"
            v-if="route === 'Reservation' || route === 'NewPartnerBooking'"
          >
            <v-text-field
              slot="activator"
              label="Activity Date"
              v-model="activity.date"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="activity.date"
              scrollable
              :min="today"
              @input="findAvailability()"
            >
              <v-spacer></v-spacer>
              <v-btn
                :depressed="true"
                flat
                color="primary"
                @click="modal = false"
                >Cancel</v-btn
              >
              <v-btn
                :depressed="true"
                flat
                color="primary"
                @click="$refs.dialog.save(activity.date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
          <v-dialog
            ref="dialog"
            persistent
            v-model="modal"
            lazy
            full-width
            width="290px"
            :return-value.sync="activity.date"
            v-if="
              route === 'NewBooking' ||
              route === 'EditBooking' ||
              route === 'PostponeBooking'
            "
          >
            <v-text-field
              slot="activator"
              label="Activity Date"
              v-model="activity.date"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="activity.date"
              scrollable
              :min="backdate_today"
              @input="findAvailability()"
            >
              <v-spacer></v-spacer>
              <v-btn
                :depressed="true"
                flat
                color="primary"
                @click="modal = false"
                >Cancel</v-btn
              >
              <v-btn
                :depressed="true"
                flat
                color="primary"
                @click="$refs.dialog.save(activity.date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md4
        sm6
        xs12
        v-if="activity.inventory.ranger_marker === false"
      >
        <v-container>
          <v-autocomplete
            label="Adults"
            :items="adultSlots"
            v-model="activity.adults"
            no-data-text="No Slots Available"
            v-if="activity.inventory.ranger_marker === false"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md4
        sm6
        xs12
        v-if="activity.inventory.ranger_marker === false && activity.adults > 0"
      >
        <v-container>
          <v-autocomplete
            label="Residency Adult"
            v-model="activity.residency_adult"
            :items="allAdultConservationFees"
            item-text="payment_person"
            item-value="payment_public_id"
            :return-object="true"
            :loading="$loadingTrue"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex lg3 md4 sm6 xs12>
        <v-container>
          <v-autocomplete
            label="Children"
            :items="childSlots"
            v-model="activity.children"
            no-data-text="No Slots Available"
            v-if="activity.inventory.ranger_marker === false"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md4
        sm6
        xs12
        v-if="
          activity.inventory.ranger_marker === false && activity.children > 0
        "
      >
        <v-container>
          <v-autocomplete
            label="Residency Children"
            v-model="activity.residency_children"
            :items="allChildrenConservationFees"
            item-text="payment_person"
            item-value="payment_public_id"
            v-if="activity.inventory.ranger_marker === false"
            :return-object="true"
            :loading="$loadingTrue"
          ></v-autocomplete>
        </v-container>
      </v-flex>

      <v-flex
        lg3
        md3
        sm6
        xs12
        fluid
        v-if="
          route === 'NewBooking' ||
          route === 'EditBooking' ||
          route === 'PostponeBooking'
        "
      >
        <v-container>
          <v-text-field
            label="Discount (%)"
            type="number"
            min="0"
            v-model="activity.activity_discount"
          >
          </v-text-field>
        </v-container>
      </v-flex>
      <v-flex lg3 md4 sm6 xs12 v-if="activity.inventory.ranger_marker === true">
        <v-container>
          <v-autocomplete
            label="No of Rangers"
            :items="adultSlots"
            v-model="activity.adults"
            no-data-text="No Slots Available"
            v-if="activity.inventory.ranger_marker === true"
          ></v-autocomplete>
        </v-container>
      </v-flex>
        <v-flex
        lg3
        md4
        sm6
        xs12
        v-if="activity.inventory.ranger_marker === true && activity.adults > 0"
      >
        <v-container>
          <v-autocomplete
            label="Residency Adult"
            v-model="activity.residency_adult"
            :items="allAdultConservationFees"
            item-text="payment_person"
            item-value="payment_public_id"
            :return-object="true"
            :loading="$loadingTrue"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md3
        sm6
        xs12
        fluid
        v-if="
          activity.inventory.public_id ===
          '648f6bc6-96bd-446c-89c5-e988749bcdf7'
        "
      >
        <v-container>
          <v-select
            :items="['7:00 PM', '9:00 PM']"
            label="Select Preferred Time"
            v-model="activity.time_frame"
          ></v-select>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md3
        sm6
        xs12
        fluid
        v-if="
          route === 'Reservation' &&
          (activity.inventory.public_id ===
            '648f6bc6-96bd-446c-89c5-e988749bcdf7' ||
            activity.inventory.public_id ===
              '4b45eed6-d1dd-4301-acb5-eca2a682d7c6' ||
            activity.inventory.public_id ===
              '66e52cab-43cd-4974-85de-246a731d6905')
        "
      >
        <v-container>
          <v-select
            :items="allPickUpLocations"
            item-text="location_name"
            item-value="location_public_id"
            label="Select Pick Up Location"
            v-model="activity.pick_up_location"
          ></v-select>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md3
        sm6
        xs12
        fluid
        v-if="
          route === 'NewBooking' ||
          route === 'EditBooking' ||
          (route === 'PostponeBooking' &&
            activity.inventory.ranger_marker === false &&
            activity.inventory.has_extras === true)
        "
      >
        <v-container>
          <v-text-field
            label="Extra Adults"
            type="number"
            min="0"
            v-model="activity.extra_pax_adults"
            v-if="
              activity.inventory.ranger_marker === false &&
              activity.inventory.has_extras === true
            "
          >
          </v-text-field>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md4
        sm6
        xs12
        v-if="
          activity.inventory.ranger_marker === false &&
          activity.extra_pax_adults > 0
        "
      >
        <v-container>
          <v-autocomplete
            label="Residency Extra Adult"
            v-model="activity.residency_extra_adult"
            :items="allAdultConservationFees"
            item-text="payment_person"
            item-value="payment_public_id"
            :return-object="true"
            :loading="$loadingTrue"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md3
        sm6
        xs12
        fluid
        v-if="
          route === 'NewBooking' ||
          route === 'EditBooking' ||
          (route === 'PostponeBooking' &&
            activity.inventory.ranger_marker === false &&
            activity.inventory.has_extras === true)
        "
      >
        <v-container>
          <v-text-field
            label="Extra Children"
            type="number"
            v-model="activity.extra_pax_children"
            min="0"
            v-if="
              activity.inventory.ranger_marker === false &&
              activity.inventory.has_extras === true
            "
          >
          </v-text-field>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md4
        sm6
        xs12
        v-if="
          activity.inventory.ranger_marker === false &&
          activity.extra_pax_children > 0
        "
      >
        <v-container>
          <v-autocomplete
            label="Residency Extra Children"
            v-model="activity.residency_extra_children"
            :items="allChildrenConservationFees"
            item-text="payment_person"
            item-value="payment_public_id"
            v-if="activity.inventory.ranger_marker === false"
            :return-object="true"
            :loading="$loadingTrue"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex
        lg3
        md3
        sm6
        xs12
        fluid
        v-if="
          route === 'NewBooking' ||
          route === 'EditBooking' ||
          (route === 'PostponeBooking' &&
            activity.inventory.ranger_marker === true &&
            activity.inventory.has_extras === true)
        "
      >
        <v-container>
          <v-text-field
            label="Extra Rangers"
            type="number"
            min="0"
            v-model="activity.extra_pax_adults"
            v-if="
              activity.inventory.ranger_marker === true &&
              activity.inventory.has_extras === true
            "
          >
          </v-text-field>
        </v-container>
      </v-flex>
      <v-container>
        <v-flex lg3 md4 sm6 xs12>
          <v-btn
            :depressed="true"
            color="primary"
            v-if="route === 'Reservation'"
            @click="selectedItem()"
            >Add to Booking</v-btn
          >
          <v-btn
            :depressed="true"
            color="primary"
            v-else-if="route != 'PostponeBooking'"
            @click="selectedItem()"
            >Add to Booking</v-btn
          >
        </v-flex>
      </v-container>
    </v-layout>
    <v-flex
      lg3
      v-if="
        route === 'NewBooking' ||
        route === 'NewPartnerBooking' ||
        route === 'EditBooking' ||
        route === 'PostponeBooking'
      "
      style="margin-top: 50px"
    >
      <h4 style="margin-left: 5%" class="earth-color">
        AVAILABLE SLOTS : {{ Number(this.activitySlots) }}
      </h4>
    </v-flex>
    <hr />
    <div
      class="row"
      v-if="
        route === 'NewBooking' ||
        route === 'NewPartnerBooking' ||
        route === 'EditBooking'
      "
    >
      <div class="col-md-12">
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
            <tr>
              <th>Activity</th>
              <th>Amount</th>
              <th>Adults</th>
              <th>Children</th>
              <th>Extra Pax</th>
              <th>Discount</th>
              <th>Total Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(activity, key) in chosenInventory" :key="key">
              <td>{{ activity.name }}</td>
              <td>
                Child: {{ activity.currency }} {{ activity.child_price }}.
                Adult: {{ activity.currency }} {{ activity.adult_price }}
              </td>
              <td v-if="activity.adults > 0">
                {{ activity.residency_adult.payment_person }} :
                {{ activity.adults }}
              </td>
              <td v-else>{{ activity.adults }}</td>
              <td v-if="activity.children > 0">
                {{ activity.residency_children.payment_person }} :
                {{ activity.children }}
              </td>
              <td v-else>{{ activity.children }}</td>

              <td
                v-if="
                  activity.extra_pax_adults > 0 &&
                  activity.extra_pax_children > 0
                "
              >
                {{ activity.residency_extra_adult.payment_person }} :
                {{ activity.extra_pax_adults }} ,
                {{ activity.residency_extra_children.payment_person }}:
                {{ activity.extra_pax_children }}
              </td>
              <td v-else-if="activity.extra_pax_adults > 0">
                {{ activity.residency_extra_adult.payment_person }} :
                {{ activity.extra_pax_adults }} ,
              </td>
              <td v-else-if="activity.extra_pax_children > 0">
                {{ activity.residency_extra_children.payment_person }}:
                {{ activity.extra_pax_children }}
              </td>
              <td v-else>
                {{ activity.extra_pax_adults }}
              </td>
              <td>{{ activity.activity_discount }}%</td>
              <td>
                {{ currency }} {{ Math.ceil(findActivityTotal(activity)) }}
              </td>
              <td>
                <v-btn
                  :depressed="true"
                  color="error"
                  @click="removeInventory(inventory)"
                  >x</v-btn
                >
                <span></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <br />
      <div class="col-md-12" v-if="bookedInventory.length > 0">
        <h4 class="earth-color">ALREADY BOOKED</h4>
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
            <tr>
              <th>Activity</th>
              <th>Amount</th>
              <th>Children</th>
              <th>Adults</th>
              <th>Activity Date</th>
              <th>Total Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(activity, key) in bookedInventory" :key="key">
              <td>{{ activity.inventory_name }}</td>
              <td>
                Child: {{ activity.inventory_booking_currency }}
                {{ activity.inventory_booking_cost_per_child }}. Adult:
                {{ activity.inventory_booking_currency }}
                {{ activity.inventory_booking_cost_per_adult }}
              </td>
              <td>{{ activity.inventory_booking_children }}</td>
              <td>{{ activity.inventory_booking_adults }}</td>
              <td>{{ formatDate(activity.inventory_booking_date) }}</td>
              <td>
                {{ activity.inventory_booking_currency }}
                {{ activity.inventory_booking_total_cost }}
              </td>
              <td>
                <v-btn
                  :depressed="true"
                  color="error"
                  @click="removedBookedInventory(activity, key)"
                  >Delete</v-btn
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-if="route === 'PostponeBooking'">
      <div class="col-md-12" v-if="bookedInventory.length > 0">
        <h4 class="earth-color">ALREADY BOOKED</h4>
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
            <tr>
              <th>Activity</th>
              <th>Amount</th>
              <th>Children</th>
              <th>Adults</th>
              <th>Activity Date</th>
              <th>Postpone Date</th>
              <th>Total Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(activity, key) in bookedInventory" :key="key">
              <td>{{ activity.inventory_name }}</td>
              <td>
                Child: {{ activity.inventory_booking_currency }}
                {{ activity.inventory_booking_cost_per_child }}. Adult:
                {{ activity.inventory_booking_currency }}
                {{ activity.inventory_booking_cost_per_adult }}
              </td>
              <td>{{ activity.inventory_booking_children }}</td>
              <td>{{ activity.inventory_booking_adults }}</td>
              <td>{{ formatDate(activity.inventory_booking_date) }}</td>
              <td>{{ postponeDate(activity.inventory_booking_public_id) }}</td>
              <td>
                {{ activity.inventory_booking_currency }}
                {{ activity.inventory_booking_total_cost }}
              </td>
              <td>
                <v-btn
                  :depressed="true"
                  class="white--text"
                  color="#800080"
                  @click="openEditActivityDateDialog(activity, key)"
                  >Postpone</v-btn
                >
              </td>
              <v-dialog
                v-model="edit_activity_date_dialog"
                persistent
                max-width="600px"
              >
                <v-card>
                  <v-card-title>
                    <h4 class="earth-color">EDIT ACTIVITY DATE</h4>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            label="Activity"
                            required
                            disabled
                            v-model="edit_activity_date_data.activity_name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-menu
                            ref="booking_update_dialog44"
                            v-model="booking_update_dialog44"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template slot="activator">
                              <v-text-field
                                v-model="edit_activity_date_data.activity_date"
                                label="Activity Date"
                                hint="YYYY/MM/DD"
                                persistent-hint
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              color="primary"
                              v-model="edit_activity_date_data.activity_date"
                              no-title
                              @input="
                                (booking_update_dialog44 = false),
                                  findPostponeAvailability()
                              "
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="edit_activity_date_dialog = false"
                      >Close</v-btn
                    >
                    <v-btn @click="postponeInventory" color="green" flat
                      >Postpone
                    </v-btn>
                    &nbsp;
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  name: "inventory-booking",
  data() {
    return {
      today: this.$moment().format("YYYY-MM-DD"),
      backdate_today: this.$moment().subtract(7, "d").format("YYYY-MM-DD"),
      requiredRules: [(v) => !!v || "This field is required"],
      modal: false,
      route: this.$route.name,
      edit_activity_date_dialog: false,
      booking_update_dialog44: false,
      activity: {
        inventory: {},
        date: "",
        activity_discount: 0,
        adults: 0,
        children: 0,
        extra_pax_adults: 0,
        extra_pax_children: 0,
        time_frame: "",
        pick_up_location: "",
        activity_price: {},
        residency_extra_children: {},
        residency_extra_adult: {},
        residency_children: {},
        residency_adult: {},
      },
      edit_activity_date_data: {
        // date_dialog: false,
        activity_date: "",
        activity_name: "",
        inventory_booking_public_id: "",
        old_activity_date: "",
        inventory_id: "",
      },
    };
  },
  computed: {
    childSlots() {
      var slots = [];
      var available = this.calculateChildMax;
      for (var i = 0; i <= available; i++) {
        slots.push(i);
      }
      return slots;
    },
    adultSlots() {
      var slots = [];
      var available = this.calculateAdultMax;
      for (var i = 0; i <= available; i++) {
        slots.push(i);
      }
      return slots;
    },
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency;
    },
    calculateAdultMax: function () {
      return (
        Number(this.activitySlots) - Number(this.total) + this.activity.adults
      );
    },
    calculateChildMax: function () {
      return (
        Number(this.activitySlots) - Number(this.total) + this.activity.children
      );
    },
    total: function () {
      return Number(this.activity.adults) + Number(this.activity.children);
    },
    disabled_settings: function () {
      var startDate = this.$moment().format("YYYY-MM-DD");
      // var endDate = this.$store.state.BookingStore.local_booking.check_out
      // this.activity.date = this.$moment(startDate).format('YYYY, MM, DD')
      return {
        to: new Date(this.$moment(startDate).format("YYYY, MM, DD")),
        // from: new Date(this.$moment(endDate).add(1, 'd').format('YYYY, MM, DD'))
      };
    },
  },
  created() {
    if (
      this.$route.name === "Reservation" ||
      this.$route.name === "NewPartnerBooking"
    ) {
      this.$store.dispatch("check_inventory_availability_public");
      this.$store.dispatch("get_all_pick_up_locations");
      this.$store.dispatch("get_full_conservation_fees");
    } else {
      this.$store.dispatch("get_active_activities");

      this.$store.dispatch("get_full_conservation_fees");
      // this.$store.dispatch('get_active_booking_activities')
    }
  },
  //  created () {
  //   if (this.$route.name === 'Reservation' || this.$route.name === 'NewPartnerBooking') {
  //     this.$store.dispatch('check_inventory_availability_public')
  //     this.$store.dispatch('get_all_pick_up_locations')
  //   } else {
  //     this.$store.dispatch('get_active_activities')
  //   }
  // },
  methods: {
    formatDate: function (date) {
      let newDate = this.$moment(date).format("YYYY-MM-DD");
      return newDate;
    },
    convertToLocalCurrency: function (amount) {},
    postponeDate(inventoryId) {
      let beforeData = [];

      // localStorage.setItem("postponed_facility_data", JSON.stringify([]));

      if (
        JSON.parse(localStorage.getItem("postponed_inventory_data") == null)
      ) {
        beforeData = beforeData;
      } else {
        beforeData = JSON.parse(
          localStorage.getItem("postponed_inventory_data")
        );
      }
      let postponeDateArr = beforeData.filter(
        (beforeda) => beforeda.inventory_booking_public_id === inventoryId
      );
      if (postponeDateArr.length > 0) {
        return postponeDateArr[0].activity_date;
      }
    },
    postponeInventory() {
      this.edit_activity_date_dialog = false;
      let beforeData = [];

      if (
        JSON.parse(localStorage.getItem("postponed_inventory_data") == null)
      ) {
        beforeData = beforeData;
      } else {
        beforeData = JSON.parse(
          localStorage.getItem("postponed_inventory_data")
        );
      }
      let postponeIds = beforeData.map((before) => {
        return before.inventory_booking_public_id;
      });
      let postponeData = this.edit_activity_date_data;

      let postponeBookingInventoryId = postponeData.inventory_booking_public_id;
      if (postponeIds.includes(postponeBookingInventoryId)) {
        for (let i = 0; i < beforeData.length; i++) {
          let bookingInventoryId = beforeData[i].inventory_booking_public_id;
          if (bookingInventoryId == postponeBookingInventoryId) {
            beforeData[i]["activity_date"] = postponeData.activity_date;

            localStorage.setItem(
              "postponed_inventory_data",
              JSON.stringify(beforeData)
            );
          }
        }
        localStorage.setItem(
          "postponed_inventory_data",
          JSON.stringify(beforeData)
        );
      } else {
        beforeData.push(postponeData);
        localStorage.setItem(
          "postponed_inventory_data",
          JSON.stringify(beforeData)
        );
      }
      for (var k = 0; k < this.bookedInventory.length; k++) {
        let booked_inventories = this.bookedInventory[k];
        if (
          booked_inventories.inventory_booking_public_id ==
          postponeBookingInventoryId
        ) {
          if (
            postponeBookingInventoryId ==
            booked_inventories.inventory_booking_public_id
          ) {
            booked_inventories["postpone_inventory_booking_date"] =
              this.$moment(postponeData.activity_date).format("YYYY-MM-DD");
          }
        }
      }
    },
    removedBookedInventory: function (activity, key) {
      var data = {
        inventory_booking_id: activity.inventory_booking_public_id,
      };
      this.$store.dispatch("remove_booked_activity", data);
      var localInventory = JSON.parse(
        localStorage.getItem("old_activity_data")
      );
      localInventory.splice(key, 1);
      this.$store.commit("ALREADY_BOOKED_ACTIVITIES", localInventory);
      localStorage.setItem("old_activity_data", JSON.stringify(localInventory));
    },
    selectedItem: function () {
      // Queried in findAvailability ()
      // TODO: Handle cases when pricing has not been set

      // if (
      //   this.activity.adults > 0 &&
      //   Object.keys(this.activity.residency_adult).length === 0
      // ) {
      //   alert("Please select adult residency");
      // } else if (
      //   this.activity.children > 0 &&
      //   Object.keys(this.activity.residency_children).length === 0
      // ) {
      //   alert("Please select children residency");
      // }else if (
      //   this.activity.extra_pax_children > 0 &&
      //   Object.keys(this.activity.residency_extra_children).length === 0
      // ) {
      //   alert("Please select extra children residency");
      // }else if (
      //   this.activity.residency_extra_adult > 0 &&
      //   Object.keys(this.activity.residency_extra_adult).length === 0
      // ) {
      //   alert("Please select extra adults residency");
      // }
      //  else {
      this.activity.inventory.price =
        this.$store.state.ActivityStore.activity_price_at_time;
      var partnerList = [];
      var data = {
        public_id: this.activity.inventory.public_id,
        name: this.activity.inventory.name,
        date: this.$moment(this.activity.date).format("YYYY-MM-DD"),
        adults: this.activity.adults,
        adult_price: this.activity.inventory.price.adult_price,
        child_price: this.activity.inventory.price.child_price,
        currency: this.activity.inventory.price.currency_type,
        children: this.activity.children,
        ranger_marker: this.activity.inventory.ranger_marker,
        activity_discount: this.activity.activity_discount,
        discounts: this.activity.inventory.discount,
        discount_status: this.activity.inventory.discount_status,
        extra_pax_adults: this.activity.extra_pax_adults,
        extra_pax_children: this.activity.extra_pax_children,
        time_frame: this.activity.time_frame,
        pick_up_location: this.activity.pick_up_location,
        residency_children: this.activity.residency_children,
        residency_adult: this.activity.residency_adult,
        residency_extra_adult: this.activity.residency_extra_adult,
        residency_extra_children: this.activity.residency_extra_children,
      };
      var oldData = JSON.parse(localStorage.getItem("activity_data"));
      if (oldData === null) {
        partnerList.push(data);
        this.$store.commit("CHOSEN_ACTIVITIES", partnerList);
      } else {
        this.$store.commit("ADD_ACTIVITY", data);
      }
      localStorage.setItem(
        "activity_data",
        JSON.stringify(this.chosenInventory)
      );
      this.activity.inventory = {};
      this.activity.date = "";
      this.activity.adults = 0;
      this.activity.children = 0;
      this.activity.extra_pax_children = 0;
      this.activity.extra_pax_adults = 0;
      this.activity.time_frame = "";
      this.activity.pick_up_location = "";
      this.activity.activity_discount = 0;
      this.activity.residency_adult = {};
      this.activity.residency_children = {};
      this.activity.residency_extra_adult = {};
      this.activity.residency_extra_children = {};
      // }
    },
    resetActivity: function (data) {
      this.activity.date = "";
      this.$store.commit("REMOVE_AVAILABILITY");
      this.activity.inventory = data;
      this.$store.dispatch("get_activity", this.activity.inventory.public_id);
      this.activity.adults = 0;
      this.activity.children = 0;
      this.activity.time_frame = "";
      this.activity.pick_up_location = "";
    },
    findAvailability: function () {
      this.$store.dispatch("loading_true");

      var data = {
        date: this.$moment(this.activity.date).format("YYYY-MM-DD"),
        inventory_id: this.activity.inventory.public_id,
      };
      this.$store.dispatch("check_inventory_availability", data);
      // Running query for price here. Will be used when adding activity to booking
      var priceData = {
        date: this.$moment(this.activity.date).format("YYYY-MM-DD"),
        public_id: this.activity.inventory.public_id,
      };
      this.$store.dispatch("get_activity_with_pricing", priceData);
    },
    findPostponeAvailability: function () {
      this.$store.dispatch("loading_true");
      var data = {
        date: this.$moment(this.edit_activity_date_data.activity_date).format(
          "YYYY-MM-DD"
        ),
        inventory_id: this.edit_activity_date_data.inventory_id,
      };
      this.$store.dispatch("check_inventory_availability", data);

      // var priceData = {
      //   date: this.$moment(this.edit_activity_date_data.activity_date).format('YYYY-MM-DD'),
      //   public_id: this.edit_activity_date_data.inventory_booking_public_id
      // }
      // this.$store.dispatch('get_activity_with_pricing', priceData)
    },

    openEditActivityDateDialog(activity) {
      this.edit_activity_date_dialog = true;
      this.edit_activity_date_data.activity_name = activity.inventory_name;
      this.edit_activity_date_data.inventory_booking_public_id =
        activity.inventory_booking_public_id;
      this.edit_activity_date_data.inventory_id = activity.inventory_id;
      this.edit_activity_date_data.activity_date = this.$moment(
        activity.inventory_booking_date
      ).format("YYYY-MM-DD");
      this.edit_activity_date_data.old_activity_date = this.$moment(
        activity.inventory_booking_date
      ).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
</style>
